module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "marketing-partners"
  }, [_c('div', {
    staticClass: "partners-heading block-heading-font-style"
  }, [_vm._v("Vetted for Excellence")]), _vm._v(" "), _c('div', {
    staticClass: "partners-subheading block-subheading-font-style"
  }, [_vm._v("MikMak is proud to announce that we have been named as a Marketing Partner by Facebook, Snapchat and Instagram.")]), _vm._v(" "), _c('span', {
    staticClass: "partner-logos"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/business/solutions-explorer/community_management/278913029298091/MikMak",
      "target": "new"
    }
  }, [_c('img', {
    staticClass: "partner-logo",
    attrs: {
      "src": require("../assets/fb-partners.png")
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "partner-logo snap-logo",
    attrs: {
      "src": require("../assets/snapchat-partners.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/business/solutions-explorer/community_management/278913029298091/MikMak",
      "target": "new"
    }
  }, [_c('img', {
    staticClass: "partner-logo",
    attrs: {
      "src": require("../assets/ig-partners.png")
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-129cce0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/MarketingPartners.vue
// module id = 456
// module chunks = 0